import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const PersonPlusIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <g clipPath="url(#clip0_2528_126)">
            <path
              d="M11 12C13.21 12 15 10.21 15 8C15 5.79 13.21 4 11 4C8.79 4 7 5.79 7 8C7 10.21 8.79 12 11 12ZM11 6C12.1 6 13 6.9 13 8C13 9.1 12.1 10 11 10C9.9 10 9 9.1 9 8C9 6.9 9.9 6 11 6ZM11 14C8.33 14 3 15.34 3 18V20H19V18C19 15.34 13.67 14 11 14ZM5 18C5.22 17.28 8.31 16 11 16C13.7 16 16.8 17.29 17 18H5ZM21 15V12H24V10H21V7H19V10H16V12H19V15H21Z"
              fill="#222"
            />
          </g>
          <defs>
            <clipPath id="clip0_2528_126">
              <path fill="#fff" d="M0 0H24V24H0z" />
            </clipPath>
          </defs>
        </svg>
      </IconWrapper>
    )
  },
)
